/**
 * Platform Navigation Abstraction
 */

import { bridge, BridgeChannels, BridgeActions } from '../bridge';

export interface NavigationPlatform {
  /** Open URL in external browser */
  openExternal(url: string): void;
  
  /** Check if can go back */
  canGoBack(): Promise<boolean>;
  
  /** Navigate back */
  goBack(): void;
  
  /** Listen for deep links from native */
  onDeepLink(callback: (path: string) => void | null): () => void;
}

class WebNavigation implements NavigationPlatform {
  openExternal(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  async canGoBack(): Promise<boolean> {
    return window.history.length > 1;
  }

  goBack(): void {
    window.history.back();
  }

  onDeepLink(_callback: (path: string) => void): () => void {
    // Web handles deep links via URL directly
    return () => {};
  }
}

class NativeNavigation implements NavigationPlatform {
  openExternal(url: string): void {
    bridge.request(BridgeChannels.NAVIGATION, BridgeActions.OPEN_EXTERNAL, { url });
  }

  async canGoBack(): Promise<boolean> {
    return window.history.length > 1;
  }

  goBack(): void {
    window.history.back();
  }

  onDeepLink(callback: (path: string) => void): () => void {
    return bridge.on(BridgeChannels.NAVIGATION, BridgeActions.DEEP_LINK, (payload) => {
      callback(payload.path);
    });
  }
}

const webNav = new WebNavigation();
const nativeNav = new NativeNavigation();

export function getNavigationPlatform(): NavigationPlatform {
  return bridge.isNative ? nativeNav : webNav;
}

